import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import Seo from '../../components/Seo';

const PartnerMaterials = () => {
    const { t } = useTranslation();
    const { lang } = useParams();

    const materials = [
        { icon: 'fas fa-file-pdf', title: t('partners.materials.brandGuide'), desc: t('partners.materials.brandGuideDesc') },
        { icon: 'fas fa-file-powerpoint', title: t('partners.materials.salesDeck'), desc: t('partners.materials.salesDeckDesc') },
        { icon: 'fas fa-image', title: t('partners.materials.logoKit'), desc: t('partners.materials.logoKitDesc') },
        { icon: 'fas fa-file-alt', title: t('partners.materials.caseStudies'), desc: t('partners.materials.caseStudiesDesc') },
        { icon: 'fas fa-file-contract', title: t('partners.materials.termsTemplate'), desc: t('partners.materials.termsTemplateDesc') },
        { icon: 'fas fa-video', title: t('partners.materials.videoAssets'), desc: t('partners.materials.videoAssetsDesc') },
    ];

    return (
        <Fragment>
            <Seo title={`${t('partners.materials.title')} | OrbitroniX`} description={t('partners.materials.title')} url={`/${lang}/partner/materials`} />
            <Layout>
                <motion.section initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="page-title pt-150 pos-rel bg_img">
                    <div className="container">
                        <div className="page-title-wrap sd-title-wrap">
                            <div className="row mt-none-30 align-items-end">
                                <div className="col-lg-9 mt-30">
                                    <motion.div initial={{ opacity: 0, x: -50 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.3 }} className="page-title-box">
                                        <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }} className="sub-title">
                                            📁 {t('partners.title')}
                                        </motion.span>
                                        <motion.h2 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.7 }} className="title">
                                            {t('partners.materials.title')}
                                        </motion.h2>
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section>

                <motion.section initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5, duration: 0.8 }} className="pb-85 cp-det-bg">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="item-details-widget" style={{ padding: '50px' }}>
                                    <p className="text-white-50 mb-4" style={{ fontSize: '18px', lineHeight: '1.8' }}>
                                        {t('partners.materials.content')}
                                    </p>
                                    <div className="row">
                                        {materials.map((m, i) => (
                                            <div className="col-lg-4 col-md-6 mb-30" key={i}>
                                                <div style={{ background: '#0c1130', border: '1px solid #1e115b', borderRadius: '12px', padding: '30px', cursor: 'pointer', transition: 'all 0.3s' }}
                                                     onMouseEnter={e => e.currentTarget.style.borderColor = '#6c5ce7'}
                                                     onMouseLeave={e => e.currentTarget.style.borderColor = '#1e115b'}>
                                                    <i className={`${m.icon} mb-3`} style={{ fontSize: '36px', color: '#6c5ce7' }}></i>
                                                    <h5 className="text-white mb-2">{m.title}</h5>
                                                    <p className="text-white-50 mb-0" style={{ fontSize: '14px' }}>{m.desc}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section>
            </Layout>
        </Fragment>
    );
};

export default PartnerMaterials;
